import {Customization} from '@eduvision/toolkit';
import {default as CustomAppBar} from '../components/AppBar';

export const AppBar: Customization['AppBar'] = {
  component: CustomAppBar
};